import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/hidden-container/InstallPWAAlertContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/main-container/page-container/MainContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/main-container/page-container/SettingAlertContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/components/main-container/under-main-container.tsx/Header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
